// Where a new secret is kept, and whether the agent may read it (D45, D46), as the mocks'
// choice cards and the switch that turns its panel red with the risk spelled out.
import { Cloud, DeviceMobile, ShieldWarning } from "@phosphor-icons/react";
import { Switch } from "rizzui";

import { useT } from "../i18n";
import { cn } from "../ui/cn";
import { Pill } from "../ui/status";

/** Only the server for now; device-held secrets are row S30. */
export function KeptChoice() {
  const t = useT().secrets.forms.kept;
  return (
    <fieldset>
      <legend className="mb-2 text-sm font-medium text-gray-900">{t.legend}</legend>
      <div className="grid gap-2.5 sm:grid-cols-2">
        <label className="flex cursor-pointer gap-3 rounded-xl border-2 border-primary bg-primary-lighter/30 p-3.5">
          <input type="radio" name="holder" value="server" className="sr-only" checked readOnly />
          <Cloud weight="duotone" className="h-5 w-5 shrink-0 text-primary" />
          <span>
            <span className="block text-[13px] font-semibold text-gray-900">{t.server}</span>
            <span className="block text-xs text-gray-500">{t.serverHelp}</span>
          </span>
        </label>
        <label className="flex gap-3 rounded-xl border border-dashed border-muted p-3.5 opacity-70">
          <input type="radio" name="holder" value="devices" className="sr-only" disabled />
          <DeviceMobile weight="duotone" className="h-5 w-5 shrink-0 text-gray-500" />
          <span>
            <span className="flex items-center gap-1.5 text-[13px] font-semibold text-gray-900">
              {t.devices}
              <Pill tone="gray" className="px-1.5 py-0 text-[10px]">
                {t.soon}
              </Pill>
            </span>
            <span className="block text-xs text-gray-500">{t.devicesHelp}</span>
          </span>
        </label>
      </div>
    </fieldset>
  );
}

export function AgentReadable({ checked, onChange }: { checked: boolean; onChange: (on: boolean) => void }) {
  const t = useT().secrets.forms.agentReadable;
  return (
    <div className={cn("rounded-xl border p-3.5", checked ? "border-red/40 bg-red-lighter/50" : "border-muted")}>
      <Switch
        size="sm"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        label={<span className="text-[13px] font-semibold text-gray-900">{t.label}</span>}
        variant="flat"
        className="[&_input:checked]:bg-red"
      />
      <p className="mt-1.5 ps-[46px] text-xs text-gray-500">{t.off}</p>
      {checked ? (
        <div role="alert" className="mt-3 flex gap-2.5 rounded-lg bg-gray-0 p-3 text-[12.5px] text-red-dark dark:bg-gray-50">
          <ShieldWarning weight="fill" className="mt-0.5 h-4 w-4 shrink-0" />
          <span>{t.warning}</span>
        </div>
      ) : null}
    </div>
  );
}
